import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';

// GLOBAL VARIABLES
import { FORM_TABLE } from 'defaults.js';

// CORE COMPONENTS
import Button from 'core/tools/Button';

//STYLES
import styles from '../table.module.scss';
import { doCallback } from 'functions';

// MAIN COMPONENT
const DeleteButton = ({
  name,
  index,
  itemLabel = 'Item',
  item,
  handleDelete
}) => {

  // FORMIK CONTEXT
  const { values, setFieldValue } = useFormikContext() || {};

  // MEMOS
  const value = useMemo(
    () => cloneDeep(get(values, name)) || [],
    [name, values]
  )

  // CALLBACKS
  const deleteItem = useCallback(
    (item, i) => {
      if (isFunction(handleDelete)) {
        if (handleDelete(item, i)) {
          doCallback(handleDelete(item, i));
          return;
        } else {
          const newValue = cloneDeep(value);
          newValue.splice(i, 1);
          setFieldValue(name, newValue);
          return;
        }
        
      } else {
        const newValue = cloneDeep(value);
        newValue.splice(i, 1);
        setFieldValue(name, newValue);
        return;
      }
    },
    [name, value, handleDelete, setFieldValue]
  )

  // RENDER
  return (
    <Button
      className={styles.button}
      label={`Remove ${itemLabel}`}
      onClick={() => deleteItem(item,index)}
      fullWidth={false}
      {...FORM_TABLE.itemButton}
      {...FORM_TABLE.deleteButton}
      icon={{
        use: FORM_TABLE.deleteButton?.icon,
        order: 1
      }}
    />
    )
  }

// EXPORT
export default DeleteButton
